import React from 'react'

export default function ChartWrapper({ title, children }) {
	return (
		<div className="chart-container">
			<h3 className="chart-title">{title}</h3>
			{children}
		</div>
	)
}
